import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { blocksKioskEntryRoute, type Role, type LoginMethod } from '@/lib/mobile-mode';

interface KioskEntryGuardProps {
  hasUserAndProfile: boolean;
  isPinSession: boolean;
  role: Role;
  loginMethod?: LoginMethod;
  children: ReactNode;
}

// ============================================================
// KioskEntryGuard
// ============================================================
// Wraps every kiosk-surface entry route (/limited, /kiosk + its
// /c/:companyCode variants, /shared-login + its variant). None of them can
// have a route guard of their own -- they must work for a shared in-store
// device with no email session at all -- but each shows a self-serve PIN
// (or kiosk-unlock) card that flips the session into full kiosk access. For
// a role/platform mobile-mode confines to scheduling-only, an active EMAIL
// session reaching any of them is a bypass of that restriction (#1129).
//
// One shared component at every kiosk-surface Route, rather than repeating
// the check per-route, so they can't drift apart the way AuthContext's two
// pin_session readers did in #1177.
export function KioskEntryGuard({
  hasUserAndProfile,
  isPinSession,
  role,
  loginMethod,
  children,
}: KioskEntryGuardProps) {
  if (blocksKioskEntryRoute(hasUserAndProfile, isPinSession, role, loginMethod)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
